import { useContext } from 'react';
import { FlowBuilderContext } from '../context';
import useField from '__hooks/useField';
import { SmartConnectorNameInput } from '__pages/SmartConnectors/components/SmartConnectorNameInput';

export const NameInput = () => {
  const { name, nameError, setName, setNameError } =
    useContext(FlowBuilderContext);

  const [stagedName, setStagedName] = useField(name);

  const handleChange = (val: string) => {
    setStagedName(val);
    setNameError('');
  };

  const handleBlur = () => {
    setName(stagedName.trim());
  };

  return (
    <SmartConnectorNameInput
      value={stagedName}
      error={nameError}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
};
